import { useQuery } from "@tanstack/react-query";
import cookiesHelper from "../../helpers/cookies";

import { IJobApplicationListItem } from "../../interfaces/services"

import api from "../../services";

const useGetJobApplicationsByJobPost = (jobPostId: number, enabled: boolean = true) => {
    const queryFn = async (): Promise<IJobApplicationListItem[]> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`
        const res = await api.get(`misc/job-applications/job-post/${jobPostId}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['job_applications', jobPostId],
        queryFn,
        retry: false,
        enabled,
    });
}

export default useGetJobApplicationsByJobPost;